import {Companies, Superstars, TagTeams} from "./models.js";

function TalentRequest() {

    // String
    const type = null;
    const status = null;

    // Integer
    const monthsRemaining = null;

    // Boolean
    const actionCompleted = null;
    const changedRequest = null;

    // Objects
    const actionData = {};

    // Foreign keys
    const superstarId = null;
    const tagTeamId = null;
    const companyId = null;

    return {
        type,
        status,
        monthsRemaining,
        actionCompleted,
        changedRequest,
        actionData,
        superstarId,
        tagTeamId,
        companyId,
    };
}

function getTalentRequestSuperstar(talentRequest) {
    return Superstars.find({'$loki': talentRequest.superstarId})[0];
}

function getTalentRequestTagTeam(talentRequest) {
    return TagTeams.find({'$loki': talentRequest.tagTeamId})[0];
}

function getTalentRequestCompany(talentRequest) {
    return Companies.find({'$loki': talentRequest.companyId})[0];
}


export { TalentRequest, getTalentRequestCompany, getTalentRequestSuperstar, getTalentRequestTagTeam }
